import LocalizedStrings from "react-localization";
import { toast } from "react-toastify";

/* eslint-disable */
const strings = new LocalizedStrings({
    en: {
        body_too_large: "Your file is too big.",
        duplicate: "There is already another element with this name",
        style_schedule_reference: "This style is used in a schedule, you can't delete it",
        content_composition_reference: "This content is used in a composition, you can't delete it",
        playlist_schedule_reference: "This playlist is used in a schedule, you can't delete it",
        instagram_invalid_token: "Can't retrieve Instagram data, please try again later",
        Unreachable_Twitter_API: "Twitter API unavailable, please try again later",
        composition_reference: "This content is used in a composition, you can't delete it",
        datasource_content_reference: "This datasource is used in a content, you can't delete it",
        invalid_email: "Email invalid",
        invitation_already_pending: "There is already an invitation pending for this user",
        invitation_already_user: "This user is already in your organization",
        concurrent_access: "This item has been edited by someone else, please reload the page to edit",
        unexpected_error: "An unexpected error occured. Developers have been notified",
        no_license: "No more licenses available, please contact iNUI Studio to get more."
    },
    fr: {
        body_too_large: "Votre fichier est trop lourd.",
        duplicate: "Un autre élément existe déjà avec ce nom",
        style_schedule_reference: "This style is used in a schedule, you can't delete it",
        content_composition_reference: "This content is used in a composition, you can't delete it",
        playlist_schedule_reference: "This playlist is used in a schedule, you can't delete it",
        instagram_invalid_token: "Can't retrieve Instagram data, please try again later",
        Unreachable_Twitter_API: "Twitter API unavailable, please try again later",
        composition_reference: "This content is used in a composition, you can't delete it",
        datasource_content_reference: "This datasource is used in a content, you can't delete it",
        invalid_email: "Email invalide",
        invitation_already_pending: "Il y a déjà une invitation en cours pour cet utilisateur",
        invitation_already_user: "Cet utilisateur est déjà dans votre organisation",
        concurrent_access: "Cet élément à été modifié par quelqu'un d'autre, veuillez rafraichir la page pour l'éditer",
        unexpected_error: "Une erreur inattendue est survenue, notre équipe a été notifié",
        no_license: "Vous n'avez plus de licenses disponible, veuillez contacter iNUI Studio pour en obtenir"
    }
});
/* eslint-enable */

const errorCodes = [
    "body_too_large",
    "duplicate",
    "style_schedule_reference",
    "content_composition_reference",
    "playlist_schedule_reference",
    "instagram_invalid_token",
    "Unreachable_Twitter_API",
    "composition_reference",
    "datasource_content_reference",
    "invalid_email",
    "invitation_already_pending",
    "invitation_already_user",
    "concurrent_access",
    "unexpected_error",
    "no_license"
];

export function handlCustomException(errorCode) {
    if (errorCode === "concurrent_access") {
        toast.warning(strings[errorCode]);
    }
    else if (errorCodes.indexOf(errorCode) > -1) {
        toast.error(strings[errorCode]);
    }
    else {
        toast.error(strings.unexpected_error);
    }
}
